module.exports = __webpack_public_path__ + "img/thumbapron1.fafd4954.png";